/* eslint-disable */
import {tentacles} from '@/config/tentacles';
import userServices from '@/services/UserServices'

export default {
    namespaced: true,
    state: {
        loading: false,
        customers: [],
        customer: {},
    },
    mutations: {
        SET_CUSTOMERS(state, customers) {
            state.customers = customers;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
        SET_CUSTOMER(state, customer) {
            window.localStorage.setItem('customerId', customer.id.toString());
            state.customer = customer;
        },
    },
    actions: {
        setCustomers({commit, dispatch}) {
            commit('SET_LOADING', true);
            return userServices.getCustomers().then(response => {
                if (response.status === 200) {
                    commit('SET_CUSTOMERS', response.data);
                    let customer = response.data.length > 0 ? response.data[0] : {'id': 0, 'name': 'Not Set/Not Available'}
                    commit('SET_CUSTOMER', customer);
                    commit('SET_LOADING', false);
                }
            }).catch(error => {
                // console.log('Error', error);
                return error;
            });
        },
        setCustomer({commit, dispatch}, customer) {
            commit('SET_CUSTOMER', customer);
        },
        setLogout({commit, dispatch}) {
            commit('SET_CUSTOMERS', []);
        }
    },
    getters: {
        customers: state => state.customers,
        customer: state => state.customer,
    }
}
